import { captureEvent, captureException, captureMessage } from '@sentry/nextjs';

export { captureEvent, captureException, captureMessage };

export function getIgnoredErrorsAndUrlsList() {
	return {
		errors: [
			'top.GLOBALS',
			'originalCreateNotification',
			'canvas.contentDocument',
			'MyApp_RemoveAllHighlights',
			'http://tt.epicplay.com',
			"Can't find variable: ZiteReader",
			'jigsaw is not defined',
			'ComboSearch is not defined',
			'http://loading.retry.widdit.com/',
			'atomicFindClose',
			'fb_xd_fragment',
			'bmi_SafeAddOnload',
			'EBCallBackMessageReceived',
			'conduitPage',
			'Non-Error exception captured',
			'Script error.',
			'_avast_submit',
			"Can't find variable: gmo", // related to https://issuetracker.google.com/issues/396043331?pli=1
			'Load failed', // google analytics
			/This Suspense boundary received an update before it finished hydrating./i,
			/Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/,
		],
		urls: [
			/pagead\/js/i,
			/graph\.facebook\.com/i,
			/connect\.facebook\.net\/en_US\/all\.js/i,
			/eatdifferent\.com\.woopra-ns\.com/i,
			/static\.woopra\.com\/js\/woopra\.js/i,
			/extensions\//i,
			/^chrome:\/\//i,
			/^chrome-extension:\/\//i,
			/127\.0\.0\.1:4001\/isrunning/i,
			/webappstoolbarba\.texthelp\.com\//i,
			/metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
			/clarity\.ms/i,
			/webappstoolbarba\.texthelp\.com\//i,
			/metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
		],
	};
}
